export const selectAlmaTunnusEmail = state => state.almaUser.get('email')
export const selectAlmaTunnusLogoutRequested = state => state.almaUser.get('logoutRequested')
export const selectAlmaTunnusLoginRequested = state => state.almaUser.get('loginRequested')
export const selectAlmaTunnusRegisterRequested = state => state.almaUser.get('registerRequested')

